import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Button } from "primereact/button";
import "../StatementTable/StatementTable.css";
import { Toast } from "primereact/toast";
import ProductService from "../../../../service/ProductService";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

const AssignAttributes = (props) => {
  const productService = new ProductService();

  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");
  const [filters1, setFilters1] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState(null);
  const toast = useRef(null);

  useEffect(() => {
    let cancel = false;

    async function fetchAttributesData() {
      try {
        setLoading(true);

        const res = await productService.getAttributes(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });

          setLoading(false);
        } else {
          setLoading(false);
          initFilters1();
          setAttributes(res.result);
        }
      } catch (e) {
        console.log(e);
      }
    }

    fetchAttributesData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initFilters1 = () => {
    setFilters1({
      attribute: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue1("");
  };

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = { ...filters1 };
    _filters1["attribute"].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  };

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue1}
            onChange={onGlobalFilterChange1}
            placeholder={localeText("attributeSearch")}
          />
        </span>
      </div>
    );
  };

  const header1 = renderHeader1();

  async function assignAttributes() {
    try {
      setLoading(true);

      if (!selectedAttributes) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("selectAtLeastOneAttribute"),
          life: 6000,
        });
        setLoading(false);
        return;
      } else if (selectedAttributes.length > 2) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("canOnlyHaveUpTo2Attributes"),
          life: 6000,
        });
        setLoading(false);
        return;
      } else {
        for (let i = 0; i < selectedAttributes.length; i++) {
          const res = await productService.postAssignAttribute(
            localStorage.getItem("__extraconomy_token"),
            selectedAttributes[i].id,
            props.product.product.id,
            localStorage.getItem("__extraconomy_username")
          );

          if (res.messageCode !== 200000) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
              life: 6000,
            });
            if (res.messageCode === 500000) console.log(res);
            setLoading(false);
            return;
          } else {
            const resProductId = await productService.getProductById(props.product.product.id);

            if (resProductId.messageCode !== 200001) {
              toast.current.show({
                severity: "error",
                summary: localeText("error"),
                detail: localeText("data").find((msg) => msg.code === resProductId.messageCode)
                  .message,
                life: 6000,
              });
              setLoading(false);
              return;
            } else {
              props.setAssigningProduct(resProductId.result);
            }
          }
        }
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div>
      <Toast position="top-left" ref={toast} />

      {props.plan === "Manager" || props.plan === "Seller" ? (
        <>
          <div className="flex align-items-center">
            <AdvancedImage
              cldImg={cloudinaryInstance
                .image(props.product.product.imageid1)
                .resize(fill().width(600).height(600))
                .format("webp")}
              height={75}
              style={{ border: "1px solid #E0E0E0" }}
              className="border-round"
            />
            <i className="pi pi-angle-right text-4xl text-400 ml-2"></i>
            <h3 className="my-4">
              {localeText("assignAttributesToProduct")} "{props.product.product.title}"
            </h3>
          </div>
          <hr />
          <p className="text-600">{localeText("pressARowToSelect")}</p>

          <Button
            label={localeText("assign")}
            loading={loading}
            className="my-4"
            onClick={() => assignAttributes()}
          />

          <DataTable
            value={attributes}
            paginator
            responsiveLayout="scroll"
            loading={loading}
            header={header1}
            filters={filters1}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate={localeText("showingFirstToLast")}
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedAttributes}
            onSelectionChange={(e) => setSelectedAttributes(e.value)}
          >
            <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
            <Column field="attribute" header={localeText("attributeName")}></Column>
          </DataTable>
        </>
      ) : (
        <div className="text-center">
          <i className="pi pi-lock text-8xl text-400 my-4"></i>
          <h2 className="my-6">{localeText("planNotAllowed")}</h2>
        </div>
      )}
    </div>
  );
};

export default AssignAttributes;
